import { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import '../../styles/Admin.css';
import api from '../../api/api';

export default function ResetPassword() {

    const { token } = useParams();

    const [searchParams] = useSearchParams();

    const navigate = useNavigate();

    const email =
        searchParams.get('email') || '';

    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] =
        useState('');

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState('');

    const [success, setSuccess] = useState('');

    const handleSubmit = async (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        setError('');
        setSuccess('');

        if (
            password !== passwordConfirmation
        ) {

            setError(
                'Passwords do not match.'
            );

            return;
        }

        setLoading(true);

        try {

            const response = await api.post(
                '/reset-password',
                {
                    token,
                    email,
                    password,
                    password_confirmation:
                    passwordConfirmation,
                }
            );

            setSuccess(
                response.data.message
            );

            setTimeout(() => {

                navigate('/admin-login');

            }, 2000);

        } catch (err: any) {

            if (
                err.response?.data?.message
            ) {

                setError(
                    err.response.data.message
                );

            } else {

                setError(
                    'Unable to reset password.'
                );

            }

        } finally {

            setLoading(false);

        }
    };

    return (
        <div className="admin-layout">
            <div className="admin-center">

                <div className="login-card">

                    <h2>Reset Password</h2>

                    <p>
                        Enter your new password.
                    </p>

                    {success && (
                        <div className="success-box">
                            {success}
                        </div>
                    )}

                    {error && (
                        <div className="error-box">
                            {error}
                        </div>
                    )}

                    <form
                        onSubmit={handleSubmit}
                        className="login-form"
                    >

                        <label>
                            New Password
                        </label>

                        <input
                            type="password"
                            value={password}
                            onChange={(e) =>
                                setPassword(
                                    e.target.value
                                )
                            }
                            required
                        />

                        <label>
                            Confirm Password
                        </label>

                        <input
                            type="password"
                            value={passwordConfirmation}
                            onChange={(e) =>
                                setPasswordConfirmation(
                                    e.target.value
                                )
                            }
                            required
                        />

                        <button
                            type="submit"
                            disabled={loading}
                            className="login-button"
                        >
                            {loading
                                ? 'Resetting...'
                                : 'Reset Password'}
                        </button>

                    </form>

                </div>

            </div>
        </div>
    );
}
